import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/logo-updated-blue.svg'


const _hoisted_1 = {
  id: "couponPrint",
  class: "row coupon-wrapper no-gutters"
}
const _hoisted_2 = { class: "h2 col-12 col-md-10 offset-md-1 text-center" }
const _hoisted_3 = { class: "lead" }
const _hoisted_4 = { class: "col-md-10 offset-md-1 col-12 coupon-body" }
const _hoisted_5 = { class: "align-items-center d-flex justify-content-between coupon-title" }
const _hoisted_6 = { class: "float-end" }
const _hoisted_7 = {
  key: 0,
  class: ""
}
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "row coupon-details no-gutters" }
const _hoisted_10 = { class: "col-md-7 col-12" }
const _hoisted_11 = { class: "coupon-price py-2 text-start" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "row coupon-phone-wrapper" }
const _hoisted_14 = { class: "col-4" }
const _hoisted_15 = { class: "coupon-phone-text" }
const _hoisted_16 = { class: "col-4" }
const _hoisted_17 = { class: "coupon-phone-text" }
const _hoisted_18 = { class: "col-md-5 col-12" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col col-6" }
const _hoisted_21 = { class: "coupon-info-text" }
const _hoisted_22 = { class: "col col-6" }
const _hoisted_23 = { class: "coupon-info-text" }
const _hoisted_24 = { class: "col col-6" }
const _hoisted_25 = { class: "coupon-info-text" }
const _hoisted_26 = { class: "col col-6" }
const _hoisted_27 = { class: "coupon-info-text" }
const _hoisted_28 = { class: "col-12 mobile-coupon-phone-wrapper" }
const _hoisted_29 = { class: "row no-gutters" }
const _hoisted_30 = { class: "col-6" }
const _hoisted_31 = { class: "coupon-phone-text" }
const _hoisted_32 = { class: "col-6" }
const _hoisted_33 = { class: "coupon-phone-text" }
const _hoisted_34 = { class: "col col-12 coupon-info-title" }
const _hoisted_35 = { class: "col-md-3 offset-md-1 col-6 p-2" }
const _hoisted_36 = { class: "col-md-3 col-6 p-2" }
const _hoisted_37 = { class: "col-md-3 col-6 p-2" }
const _hoisted_38 = { class: "col-md-3 offset-md-1 col-6 p-2" }
const _hoisted_39 = {
  class: "modal fade",
  id: "exampleModalCenter",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalCenterTitle",
  "aria-hidden": "true"
}
const _hoisted_40 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_41 = { class: "modal-content" }
const _hoisted_42 = { class: "modal-body" }
const _hoisted_43 = { class: "container-fluid" }
const _hoisted_44 = { class: "row" }
const _hoisted_45 = { class: "col" }
const _hoisted_46 = { class: "row footer" }
const _hoisted_47 = { class: "col col-md-6 offset-md-6" }
const _hoisted_48 = {
  class: "modal fade",
  id: "phoneNumberModal",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "phoneNumberModalTitle",
  "aria-hidden": "true"
}
const _hoisted_49 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_50 = { class: "modal-content" }
const _hoisted_51 = { class: "modal-body" }
const _hoisted_52 = { class: "container-fluid" }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col" }
const _hoisted_55 = { class: "row footer" }
const _hoisted_56 = { class: "col col-md-6 offset-md-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_back_to_previous_page = _resolveComponent("back-to-previous-page")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_prc_button = _resolveComponent("prc-button")!
  const _component_prc_input = _resolveComponent("prc-input")!
  const _component_loading_spinner = _resolveComponent("loading-spinner")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["alert alert-success alert-dismissible mail-alert", { 'show-alert': _ctx.mailSent || _ctx.smsSent }])
    }, [
      _createVNode(_component_router_link, {
        to: "#",
        class: "btn-close",
        onClick: $options.closeAlert
      }, null, 8, ["onClick"]),
      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "notification-text" }, "Your smart prescription savings coupon has been sent.", -1))
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["alert alert-danger alert-dismissible mail-alert", { 'show-alert': _ctx.mailSendFailure || _ctx.smsSendFailure }])
    }, [
      _createVNode(_component_router_link, {
        to: "#",
        class: "btn-close text-dark",
        onClick: $options.closeAlert
      }, null, 8, ["onClick"]),
      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "danger-text" }, "Failed to send your prescription savings coupon.", -1))
    ], 2),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_back_to_previous_page, {
        class: "col-12 col-md-10 offset-md-1",
        returnURL: _ctx.returnURL,
        backText: "Back to Search Results"
      }, null, 8, ["returnURL"]),
      _createElementVNode("h1", _hoisted_2, [
        _createElementVNode("b", _hoisted_3, "Show this smart coupon at " + _toDisplayString(_ctx.coupon.pharmacyName) + " to claim your savings", 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[4] || (_cache[4] = _createElementVNode("div", null, [
            _createElementVNode("div", { class: "d-inline-block" }, [
              _createElementVNode("img", {
                class: "img-fluid",
                src: _imports_0,
                alt: "IntelligentRx Logo"
              }),
              _createElementVNode("div", { class: "logo-text d-inline-block" }, " The smart prescription savings coupon ")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.logoURL)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("img", {
                    src: _ctx.logoURL,
                    alt: _ctx.coupon.pharmacyName,
                    style: {"max-height":"100px"}
                  }, null, 8, _hoisted_8)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("b", null, "$" + _toDisplayString(_ctx.price), 1)
            ]),
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(_ctx.coupon.ln) + " " + _toDisplayString(_ctx.coupon.qty) + " " + _toDisplayString(_ctx.coupon.form), 1),
              (_ctx.coupon.dosage)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, ", " + _toDisplayString(_ctx.coupon.dosage), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "coupon-phone-title" }, "Customer questions call:", -1)),
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.coupon.servicePhone), 1)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "coupon-phone-title" }, "Pharmacist questions call:", -1)),
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.coupon.helpdeskPhone), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "coupon-right-info" }, "Bin", -1)),
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.coupon.rxBin), 1)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "coupon-right-info" }, "PCN", -1)),
                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.coupon.rxPcn), 1)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "coupon-right-info" }, "Member ID", -1)),
                _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.coupon.memberId), 1)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "coupon-right-info" }, "Group", -1)),
                _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.coupon.rxGroup), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "mobile-coupon-phone-title" }, " Customer questions call: ", -1)),
                _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.coupon.helpdeskPhone), 1)
              ]),
              _createElementVNode("div", _hoisted_32, [
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "mobile-coupon-phone-title" }, " Pharmacist questions call: ", -1)),
                _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.coupon.servicePhone), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _cache[13] || (_cache[13] = _createElementVNode("strong", null, "Discount only - This is NOT Insurance.", -1)),
            _createTextVNode(" This is your estimated price at " + _toDisplayString(_ctx.coupon.pharmacyName) + ". The pharmacy will provide the exact pricing. ", 1)
          ])
        ])
      ]),
      _cache[22] || (_cache[22] = _createElementVNode("h2", { class: "col-12 py-2 text-center" }, "Save This Coupon", -1)),
      _createElementVNode("div", _hoisted_35, [
        _createVNode(_component_prc_button, {
          type: "info",
          class: "align-items-center",
          "data-bs-toggle": "modal",
          "data-bs-target": "#exampleModalCenter",
          "aria-label": "Send this coupon to yourself via an email"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, [
              _createVNode(_component_font_awesome_icon, {
                class: "px-2",
                icon: "fa fa-envelope",
                size: "lg",
                "aria-hidden": "true",
                width: "24px",
                height: "24px"
              }),
              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "btn-inner-text" }, "Email", -1))
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_36, [
        _createVNode(_component_prc_button, {
          type: "info",
          class: "align-items-center",
          "data-bs-toggle": "modal",
          "data-bs-target": "#phoneNumberModal",
          "aria-label": "Send this coupon to yourself via a text message"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, [
              _createVNode(_component_font_awesome_icon, {
                class: "px-2",
                icon: "fa fa-comment",
                size: "lg",
                "aria-hidden": "true",
                width: "24px",
                height: "24px"
              }),
              _cache[15] || (_cache[15] = _createElementVNode("span", { class: "btn-inner-text" }, "Text", -1))
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createVNode(_component_prc_button, {
          type: "info",
          class: "align-items-center",
          onClick: $options.getPrintMethod,
          "aria-label": "Download this coupon via the Print dialog"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, [
              _createVNode(_component_font_awesome_icon, {
                class: "px-2",
                icon: "fa fa-download",
                size: "lg",
                "aria-hidden": "true",
                width: "24px",
                height: "24px"
              }),
              _cache[16] || (_cache[16] = _createElementVNode("span", { class: "btn-inner-text" }, "Download", -1))
            ])
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _cache[23] || (_cache[23] = _createElementVNode("h2", { class: "col-12 py-2 text-center" }, "Pharmacy Tools", -1)),
      _createElementVNode("div", _hoisted_38, [
        _createVNode(_component_prc_button, {
          type: "info",
          class: "align-items-center",
          onClick: $options.prescriptionTransfer,
          "aria-label": "Link to transfer your prescription to this pharmacy"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, [
              _createVNode(_component_font_awesome_icon, {
                class: "px-2",
                icon: "fa fa-arrow-right",
                size: "lg",
                "aria-hidden": "true",
                width: "24px",
                height: "24px"
              }),
              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "btn-inner-text" }, "Transfer Prescription", -1))
            ])
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _cache[19] || (_cache[19] = _createStaticVNode("<div class=\"row\" data-v-b2380e80><div class=\"col\" data-v-b2380e80><div class=\"modal-header\" data-v-b2380e80><h1 class=\"modal-title h5\" id=\"exampleModalCenterTitle\" data-v-b2380e80> Enter your email address </h1><button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\" data-v-b2380e80></button></div></div></div>", 1)),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _createVNode(_component_prc_input, {
                      modelValue: _ctx.email,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                      name: "email",
                      label: "Email Address",
                      placeholder: "example@domain.com",
                      state: $options.validateEmail,
                      errorMessage: "Please enter a valid email address"
                    }, null, 8, ["modelValue", "state"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    (_ctx.showSpinner)
                      ? (_openBlock(), _createBlock(_component_loading_spinner, { key: 0 }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_prc_button, {
                      type: "info",
                      disabled: !$options.validateEmail,
                      onClick: $options.sendEmail,
                      "aria-label": 'Send this coupon to yourself at the email address: ' +
                                                _ctx.email
                                                
                    }, {
                      default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                        _createTextVNode("Send ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["disabled", "onClick", "aria-label"])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                _cache[21] || (_cache[21] = _createStaticVNode("<div class=\"row\" data-v-b2380e80><div class=\"col\" data-v-b2380e80><div class=\"modal-header\" data-v-b2380e80><h1 class=\"modal-title h5\" id=\"phoneNumberModalTitle\" data-v-b2380e80> Enter your phone number </h1><button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\" data-v-b2380e80></button></div></div></div>", 1)),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _createVNode(_component_prc_input, {
                      modelValue: _ctx.sms,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sms) = $event)),
                      name: "SMS",
                      label: "Phone Number",
                      placeholder: "123-456-7890",
                      state: $options.validateSMS,
                      errorMessage: "Please enter a valid Phone Number"
                    }, null, 8, ["modelValue", "state"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    (_ctx.showSpinner)
                      ? (_openBlock(), _createBlock(_component_loading_spinner, { key: 0 }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_prc_button, {
                      type: "info",
                      disabled: !$options.validateSMS,
                      onClick: $options.sendSMS,
                      "aria-label": 'Send this coupon to yourself at the phone number: ' +
                                            _ctx.sms
                                            
                    }, {
                      default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                        _createTextVNode("Send ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["disabled", "onClick", "aria-label"])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}